import "core-js/modules/es.array.reverse.js";
var _class, _GeoJsonStratum;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import bbox from "@turf/bbox";
import i18next from "i18next";
import { action, computed, makeObservable, observable, onBecomeObserved, onBecomeUnobserved, override, reaction, runInAction, toJS } from "mobx";
import { createTransformer } from "mobx-utils";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import clone from "terriajs-cesium/Source/Core/clone";
import Color from "terriajs-cesium/Source/Core/Color";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import Iso8601 from "terriajs-cesium/Source/Core/Iso8601";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import TimeInterval from "terriajs-cesium/Source/Core/TimeInterval";
import TimeIntervalCollection from "terriajs-cesium/Source/Core/TimeIntervalCollection";
import BillboardGraphics from "terriajs-cesium/Source/DataSources/BillboardGraphics";
import ColorMaterialProperty from "terriajs-cesium/Source/DataSources/ColorMaterialProperty";
import ConstantProperty from "terriajs-cesium/Source/DataSources/ConstantProperty";
import CustomDataSource from "terriajs-cesium/Source/DataSources/CustomDataSource";
import CzmlDataSource from "terriajs-cesium/Source/DataSources/CzmlDataSource";
import Entity from "terriajs-cesium/Source/DataSources/Entity";
import GeoJsonDataSource from "terriajs-cesium/Source/DataSources/GeoJsonDataSource";
import PointGraphics from "terriajs-cesium/Source/DataSources/PointGraphics";
import PolylineGraphics from "terriajs-cesium/Source/DataSources/PolylineGraphics";
import HeightReference from "terriajs-cesium/Source/Scene/HeightReference";
import filterOutUndefined from "../Core/filterOutUndefined";
import formatPropertyValue from "../Core/formatPropertyValue";
import { explodeMultiPoint, isPoint } from "../Core/GeoJson";
import hashFromString from "../Core/hashFromString";
import isDefined from "../Core/isDefined";
import { isJsonArray, isJsonNumber, isJsonObject } from "../Core/Json";
import { isJson } from "../Core/loadBlob";
import StandardCssColors from "../Core/StandardCssColors";
import TerriaError, { networkRequestError } from "../Core/TerriaError";
import ProtomapsImageryProvider from "../Map/ImageryProvider/ProtomapsImageryProvider";
import { ProtomapsGeojsonSource } from "../Map/Vector/Protomaps/ProtomapsGeojsonSource";
import { tableStyleToProtomaps } from "../Map/Vector/Protomaps/tableStyleToProtomaps";
import Reproject from "../Map/Vector/Reproject";
import CatalogMemberMixin from "../ModelMixins/CatalogMemberMixin";
import UrlMixin from "../ModelMixins/UrlMixin";
import proxyCatalogItemUrl from "../Models/Catalog/proxyCatalogItemUrl";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import StratumOrder from "../Models/Definition/StratumOrder";
import TerriaFeature from "../Models/Feature/Feature";
import TableStylingWorkflow from "../Models/Workflows/TableStylingWorkflow";
import createLongitudeLatitudeFeaturePerRow from "../Table/createLongitudeLatitudeFeaturePerRow";
import TableAutomaticStylesStratum from "../Table/TableAutomaticStylesStratum";
import { createRowGroupId } from "../Table/TableStyle";
import { GeoJsonTraits } from "../Traits/TraitsClasses/GeoJsonTraits";
import { RectangleTraits } from "../Traits/TraitsClasses/MappableTraits";
import FeatureInfoUrlTemplateMixin from "./FeatureInfoUrlTemplateMixin";
import { isDataSource } from "./MappableMixin";
import TableMixin from "./TableMixin";
import PinBuilder from "terriajs-cesium/Source/Core/PinBuilder";
import VerticalOrigin from "terriajs-cesium/Source/Scene/VerticalOrigin";
export const FEATURE_ID_PROP = "_id_";
const SIMPLE_STYLE_KEYS = ["marker-size", "marker-color", "marker-symbol", "marker-opacity", "marker-url", "stroke", "stroke-opacity", "stroke-width", "marker-stroke-width", "polyline-stroke-width", "polygon-stroke-width", "fill", "fill-opacity"];
let GeoJsonStratum = (_class = (_GeoJsonStratum = class GeoJsonStratum extends LoadableStratum(GeoJsonTraits) {
  constructor(_item) {
    super();
    this._item = _item;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new GeoJsonStratum(newModel);
  }
  static load(item) {
    return new GeoJsonStratum(item);
  }
  get rectangle() {
    if (this._item._readyData) {
      try {
        const geojsonBbox = bbox(this._item._readyData);
        return createStratumInstance(RectangleTraits, {
          west: geojsonBbox[0],
          south: geojsonBbox[1],
          east: geojsonBbox[2],
          north: geojsonBbox[3]
        });
      } catch (e) {
        TerriaError.from(e, "Failed to create `rectangle` for GeoJSON").log();
      }
    }
  }
  get opacity() {
    return 1;
  }
  get disableSplitter() {
    // Disable splitter if mapItems has any datasources
    return this._item.mapItems.find(isDataSource) ? true : undefined;
  }
  get disableOpacityControl() {
    // Disable opacity if mapItems has any datasources
    return this._item.mapItems.find(isDataSource) ? true : undefined;
  }
  get showDisableStyleOption() {
    return true;
  }
  get forceCesiumPrimitives() {
    // Disable TableStyling for the following:
    // If MultiPoint features exist
    // If more than 50% of features have simple style properties - disable table styling
    if (this._item.featureCounts.multiPoint > 0 || this._item.featureCounts.simpleStyle / this._item.featureCounts.total >= 0.5) {
      return true;
    }
  }
}, _defineProperty(_GeoJsonStratum, "stratumName", "geojson"), _GeoJsonStratum), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableSplitter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableSplitter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableOpacityControl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableOpacityControl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forceCesiumPrimitives", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "forceCesiumPrimitives"), _class.prototype), _class);
StratumOrder.addLoadStratum(GeoJsonStratum.stratumName);
function GeoJsonMixin(Base) {
  var _dec, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  let GeoJsonMixin = (_dec = observable.ref, _class2 = class GeoJsonMixin extends TableMixin(FeatureInfoUrlTemplateMixin(UrlMixin(Base))) {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "_dataSource", _descriptor, this);
      _initializerDefineProperty(this, "_imageryProvider", _descriptor2, this);
      _defineProperty(this, "tableStyleReactionDisposer", void 0);
      /** Geojson FeatureCollection in WGS84 */
      _initializerDefineProperty(this, "_readyData", _descriptor3, this);
      /** Number of features in _readyData FeatureCollection */
      _initializerDefineProperty(this, "featureCounts", _descriptor4, this);
      // Create point features using TableMixin.createLongitudeLatitudeFeaturePerRow
      // Used with table styling
      // Line and Polygon features are handled by Protomaps
      _defineProperty(this, "createPoints", createTransformer(style => {
        if (!this.readyData) return;
        const latitudes = [];
        const longitudes = [];
        for (let i = 0; i < this.readyData.features.length; i++) {
          const feature = this.readyData.features[i];
          if (!isPoint(feature)) {
            latitudes.push(null);
            longitudes.push(null);
            continue;
          }
          latitudes.push(feature.geometry.coordinates[1]);
          longitudes.push(feature.geometry.coordinates[0]);
        }
        const dataSource = new CustomDataSource(this.name || "Table");
        dataSource.entities.suspendEvents();
        const features = createLongitudeLatitudeFeaturePerRow(style, longitudes, latitudes);

        // _catalogItem property is needed for some feature picking functions (eg FeatureInfoUrlTemplateMixin)
        features.forEach(f => {
          f._catalogItem = this;
          dataSource.entities.add(f);
        });
        dataSource.entities.resumeEvents();
        return dataSource;
      }));
      makeObservable(this);
      // Add GeoJsonStratum
      if (this.strata.get(GeoJsonStratum.stratumName) === undefined) {
        runInAction(() => {
          this.strata.set(GeoJsonStratum.stratumName, GeoJsonStratum.load(this));
        });
      }

      // Add TableAutomaticStylesStratum
      if (this.strata.get(TableAutomaticStylesStratum.stratumName) === undefined) {
        this.strata.set(TableAutomaticStylesStratum.stratumName, new TableAutomaticStylesStratum(this));
      }

      // Setup table style reactions
      // We should only update geojson table styling when our map items have consumers
      onBecomeObserved(this, "mapItems", this.startTableStyleReaction.bind(this));
      onBecomeUnobserved(this, "mapItems", this.stopTableStyleReaction.bind(this));
    }
    startTableStyleReaction() {
      if (!this.tableStyleReactionDisposer) {
        // Update protomaps imagery provider if activeTableStyle changes
        this.tableStyleReactionDisposer = reaction(() => getStyleReactiveDependencies(this), () => {
          if (this._imageryProvider && this.readyData && this.useTableStylingAndProtomaps) {
            runInAction(() => {
              this._imageryProvider = this.createProtomapsImageryProvider(this.readyData);
            });
          }
        },
        // Fire immediately, just in case reactions change while not observing mapItems
        {
          fireImmediately: true
        });
      }
    }
    stopTableStyleReaction() {
      if (this.tableStyleReactionDisposer) {
        this.tableStyleReactionDisposer();
        this.tableStyleReactionDisposer = undefined;
      }
    }
    get isGeoJson() {
      return true;
    }
    get name() {
      if (CatalogMemberMixin.isMixedInto(this.sourceReference)) {
        return super.name || this.sourceReference.name;
      }
      return super.name;
    }
    get cacheDuration() {
      if (isDefined(super.cacheDuration)) {
        return super.cacheDuration;
      }
      return "1d";
    }

    /**
     * Returns the final raw data after all transformations are applied.
     * (Geojson FeatureCollection in WGS84)
     */
    get readyData() {
      return this._readyData;
    }
    get _canExportData() {
      return isDefined(this.readyData);
    }
    async _exportData() {
      if (isDefined(this.readyData)) {
        let name = this.name || this.uniqueId || "data.geojson";
        if (!isJson(name)) {
          name = "".concat(name, ".geojson");
        }
        return {
          name,
          file: new Blob([JSON.stringify(this.readyData)])
        };
      }
      throw new TerriaError({
        sender: this,
        message: "No data available to download."
      });
    }
    get mapItems() {
      if (this.isLoadingMapItems) {
        return [];
      }
      if (this._dataSource) {
        this._dataSource.show = this.show;
      }
      let points = undefined;
      if (this.useTableStylingAndProtomaps) {
        const pts = this.createPoints(this.activeTableStyle);
        if (pts && pts.entities.values.length !== 0) {
          points = pts;
          points.show = this.show;
        }
      }
      return filterOutUndefined([points, this._dataSource, this._imageryProvider ? {
        imageryProvider: this._imageryProvider,
        show: this.show,
        alpha: this.opacity,
        clippingRectangle: undefined
      } : undefined]);
    }

    /**
     * {@link FeatureInfoUrlTemplateMixin.buildFeatureFromPickResult}
     */
    buildFeatureFromPickResult(_screenPosition, pickResult) {
      if (pickResult instanceof Entity) {
        return TerriaFeature.fromEntityCollectionOrEntity(pickResult);
      } else if (isDefined(pickResult === null || pickResult === void 0 ? void 0 : pickResult.id)) {
        return TerriaFeature.fromEntityCollectionOrEntity(pickResult.id);
      }
    }

    /** Only use MapboxVectorTiles (through geojson-vt and protomaps.js) if enabled and not using unsupported traits
     * For more info see GeoJsonMixin.forceLoadMapItems
     */
    get useTableStylingAndProtomaps() {
      return !this.forceCesiumPrimitives && !isDefined(this.czmlTemplate) &&
      // Table styling doesn't support the old GeoJson StyleTraits
      Object.keys(this.style.traits).every(styleTrait => !isDefined(this.style[styleTrait])) && !isDefined(this.timeProperty) && !isDefined(this.heightProperty) && (!isDefined(this.perPropertyStyles) || this.perPropertyStyles.length === 0);
    }

    /** Remove chart items from TableMixin.chartItems */
    get chartItems() {
      return [];
    }

    /**
     * Forces load of the geojson data. This method does _not_ need to consider
     * whether the geojson is already loaded.
     *
     * It is guaranteed that `loadMetadata` has finished before this is called.
     *
     * You **can not** make changes to observables until **after** an asynchronous call {@see AsyncLoader}.
     *
     * Errors can be thrown here.
     */

    /** GeojsonMixin has 3 rendering modes:
     * - CZML:
     *    - if `czmlTemplate` is defined (see `GeoJsonTraits.czmlTemplate`)
     * - Table styling / Mapbox vector tiles (through geojson-vt and protomaps.js)
     *    - Will be used by default, if not using unsupported traits (see below)
     * - Cesium primitives if:
     *    - `GeoJsonTraits.forceCesiumPrimitives = true`
     *    - Using `timeProperty` or `heightProperty` or `perPropertyStyles` or simple-style `marker-symbol`
     *    - More than 50% of GeoJSON features have simply-style properties (eg "fill-color")
     *    - MultiPoint features are in GeoJSON (not supported by Table styling)
     */
    async forceLoadMapItems() {
      const czmlTemplate = this.czmlTemplate;
      const filterByProperties = this.filterByProperties;
      const explodeMultiPoints = this.explodeMultiPoints;
      let geoJson;
      try {
        var _this$_dataSource;
        geoJson = await this.forceLoadGeojsonData();
        if (geoJson === undefined) {
          return;
        }
        const geoJsonWgs84 = await reprojectToGeographic(geoJson, this.terria.configParameters.proj4ServiceBaseUrl);
        const featureCounts = {
          point: 0,
          multiPoint: 0,
          line: 0,
          polygon: 0,
          simpleStyle: 0,
          total: 0
        };

        // We will re-add features depending if filterByProperties - or geometry is invalid
        const features = geoJsonWgs84.features;
        geoJsonWgs84.features = [];
        let currentFeatureId = 0;
        for (let i = 0; i < features.length; i++) {
          const feature = features[i];

          // Ignore features without geometry or type
          if (!isJsonObject(feature.geometry, false) || !feature.geometry.type) continue;

          // Ignore features with invalid coordinates
          if (!isJsonArray(feature.geometry.coordinates, false) || feature.geometry.coordinates.length === 0) continue;
          if (!feature.properties) {
            feature.properties = {};
          }

          // Filter features by `featureFilterByProps` trait if defined
          if (filterByProperties && !Object.entries(filterByProperties).every(_ref => {
            let [key, value] = _ref;
            return feature.properties[key] === value;
          })) {
            continue;
          }
          if (explodeMultiPoints && feature.geometry.type === "MultiPoint") {
            // Replace the MultiPoint with equivalent Point features and repeat
            // the iteration to pick up the exploded features.
            features.splice(i, 1, ...explodeMultiPoint(feature));
            i--;
            continue;
          }
          geoJsonWgs84.features.push(feature);

          // Add feature index to FEATURE_ID_PROP ("_id_") feature property
          // This is used to refer to each feature in TableMixin (as row ID)
          const properties = feature.properties;
          properties[FEATURE_ID_PROP] = currentFeatureId;

          // Count features types
          if (feature.geometry.type === "Point") {
            featureCounts.point++;
          } else if (feature.geometry.type === "MultiPoint") {
            featureCounts.multiPoint++;
          } else if (feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString") {
            featureCounts.line++;
          } else if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
            featureCounts.polygon++;
          }

          // Does feature include simplestyle-spec properties (eg "fill-colour)")
          if (SIMPLE_STYLE_KEYS.find(key => properties[key])) {
            featureCounts.simpleStyle++;
          }
          featureCounts.total++;
          // Note it is important to increment currentFeatureId only if we are including the feature - as this needs to match the row ID in TableMixin (through dataColumnMajor)
          currentFeatureId++;
        }
        runInAction(() => {
          this.featureCounts = featureCounts;
          if (featureCounts.total === 0) {
            this._readyData = undefined;
          } else {
            this._readyData = geoJsonWgs84;
          }
        });
        if (isDefined(czmlTemplate)) {
          const dataSource = await this.loadCzmlDataSource(geoJsonWgs84);
          runInAction(() => {
            this._dataSource = dataSource;
            this._imageryProvider = undefined;
          });
        } else if (runInAction(() => this.useTableStylingAndProtomaps)) {
          runInAction(() => {
            this._imageryProvider = this.createProtomapsImageryProvider(geoJsonWgs84);
          });
        } else {
          const dataSource = await this.loadGeoJsonDataSource(geoJsonWgs84);
          if (this.clustering.enabled) {
            const pinBackgroundColor = this.clustering.pinBackgroundColor;
            const pinSize = this.clustering.pinSize;
            const pinBuilder = new PinBuilder();
            dataSource.clustering.enabled = true;
            dataSource.clustering.pixelRange = this.clustering.pixelRange;
            dataSource.clustering.minimumClusterSize = this.clustering.minimumClusterSize;
            dataSource.clustering.clusterEvent.addEventListener(function (entities, cluster) {
              cluster.label.show = false;
              cluster.billboard.verticalOrigin = VerticalOrigin.BOTTOM;
              cluster.billboard.image = pinBuilder.fromText(entities.length.toLocaleString(), Color.fromCssColorString(pinBackgroundColor), pinSize).toDataURL();
              cluster.billboard.show = true;
            });
          }
          runInAction(() => {
            this._dataSource = dataSource;
            this._imageryProvider = undefined;
          });
        }
        (_this$_dataSource = this._dataSource) === null || _this$_dataSource === void 0 || _this$_dataSource.entities.values.forEach(entity => entity._catalogItem = this);
      } catch (e) {
        throw networkRequestError(TerriaError.from(e, {
          title: i18next.t("models.geoJson.errorLoadingTitle"),
          message: i18next.t("models.geoJson.errorParsingMessage")
        }));
      }
    }
    addPerPropertyStyleToGeoJson(fc) {
      for (let i = 0; i < fc.features.length; i++) {
        const featureProperties = fc.features[i].properties;
        if (featureProperties === null) {
          return;
        }
        const featurePropertiesEntires = Object.entries(featureProperties);
        const matchedStyles = this.perPropertyStyles.filter(style => {
          var _style$properties;
          const stylePropertiesEntries = Object.entries((_style$properties = style.properties) !== null && _style$properties !== void 0 ? _style$properties : {});

          // For every key-value pair in the style, is there an identical one in the feature's properties?
          return stylePropertiesEntries.every(_ref2 => {
            let [styleKey, styleValue] = _ref2;
            return featurePropertiesEntires.find(_ref3 => {
              let [featKey, featValue] = _ref3;
              if (typeof styleValue === "string" && !style.caseSensitive) {
                return featKey === styleKey && (typeof featValue === "string" ? featValue : featValue.toString()).toLowerCase() === styleValue.toLowerCase();
              }
              return featKey === styleKey && featValue === styleValue;
            }) !== undefined;
          });
        });
        if (matchedStyles !== undefined) {
          for (const matched of matchedStyles) {
            for (const trait of Object.keys(matched.style.traits)) {
              var _matched$style$trait;
              featureProperties[trait] = // @ts-expect-error - TS can't tell that `trait` is of the correct index type for style
              (_matched$style$trait = matched.style[trait]) !== null && _matched$style$trait !== void 0 ? _matched$style$trait : featureProperties[trait];
            }
          }
        }
      }
    }
    createProtomapsImageryProvider(geoJson) {
      // Don't need protomaps unless we have lines and polygons to show
      // Points are handled by this.createPoints()
      if (this.featureCounts.line + this.featureCounts.polygon === 0) return;
      const {
        paintRules,
        labelRules,
        currentTimeRows
      } = tableStyleToProtomaps(this);
      let protomapsData = Object.assign({}, geoJson, {
        features: geoJson.features.filter(f => f.geometry.type !== "Point")
      });

      // Are we creating a protomaps imagery provider with the same geojson data (readyData)?
      // If so we can copy GeojsonSource over to save running geojson-vt again
      if (this._imageryProvider instanceof ProtomapsImageryProvider && this._imageryProvider.source instanceof ProtomapsGeojsonSource && this._imageryProvider.source.geojsonObject === this.readyData) {
        protomapsData = this._imageryProvider.source;
      }
      let provider = new ProtomapsImageryProvider({
        terria: this.terria,
        data: protomapsData,
        id: this.uniqueId,
        paintRules,
        labelRules,
        // Process picked features to add terriaFeatureData (with rowIds)
        // This is used by tableFeatureInfoContext to add time-series chart
        processPickedFeatures: async features => {
          if (!currentTimeRows) return features;
          const processedFeatures = [];
          features.forEach(f => {
            var _f$properties;
            const rowId = (_f$properties = f.properties) === null || _f$properties === void 0 ? void 0 : _f$properties[FEATURE_ID_PROP];
            if (isDefined(rowId) && currentTimeRows !== null && currentTimeRows !== void 0 && currentTimeRows.includes(rowId)) {
              var _this$activeTableStyl;
              // To find rowIds for all features in a row group:
              // re-create the rowGroupId and then look up in the activeTableStyle.rowGroups
              const rowGroupId = createRowGroupId(rowId, this.activeTableStyle.groupByColumns);
              const terriaFeatureData = _objectSpread(_objectSpread({}, f.data), {}, {
                type: "terriaFeatureData",
                rowIds: (_this$activeTableStyl = this.activeTableStyle.rowGroups.find(group => group[0] === rowGroupId)) === null || _this$activeTableStyl === void 0 ? void 0 : _this$activeTableStyl[1]
              });
              f.data = terriaFeatureData;
              processedFeatures.push(f);
            }
          });
          return processedFeatures;
        }
      });
      provider = this.wrapImageryPickFeatures(provider);
      return provider;
    }
    async loadCzmlDataSource(geoJson) {
      const czmlTemplate = runInAction(() => toJS(this.czmlTemplate));
      const rootCzml = [{
        id: "document",
        name: "CZML",
        version: "1.0"
      }];

      // Create a czml packet for each geoJson Point/Polygon feature
      // For point: set czml position (CartographicDegrees) to point coordinates
      // For polygon: set czml positions array (CartographicDegreesListValue) for the `polygon` property

      // Set czml properties to feature properties
      for (let i = 0; i < geoJson.features.length; i++) {
        var _feature$geometry, _feature$geometry2, _feature$geometry3, _feature$geometry5, _feature$geometry6;
        const feature = geoJson.features[i];
        if (feature === null) {
          continue;
        }
        if (((_feature$geometry = feature.geometry) === null || _feature$geometry === void 0 ? void 0 : _feature$geometry.type) === "Point") {
          var _this$czmlTemplate, _czml$properties, _feature$properties;
          const czml = clone(czmlTemplate !== null && czmlTemplate !== void 0 ? czmlTemplate : {}, true);
          const point = feature.geometry;
          const coords = point.coordinates;

          // Add height = 0 if no height provided
          if (coords.length === 2) {
            coords[2] = 0;
          }
          if (isJsonNumber((_this$czmlTemplate = this.czmlTemplate) === null || _this$czmlTemplate === void 0 ? void 0 : _this$czmlTemplate.heightOffset)) {
            coords[2] += this.czmlTemplate.heightOffset;
          }
          czml.position = {
            cartographicDegrees: point.coordinates
          };
          czml.properties = Object.assign((_czml$properties = czml.properties) !== null && _czml$properties !== void 0 ? _czml$properties : {}, stringifyFeatureProperties((_feature$properties = feature.properties) !== null && _feature$properties !== void 0 ? _feature$properties : {}));
          rootCzml.push(czml);
        } else if ((((_feature$geometry2 = feature.geometry) === null || _feature$geometry2 === void 0 ? void 0 : _feature$geometry2.type) === "Polygon" || ((_feature$geometry3 = feature.geometry) === null || _feature$geometry3 === void 0 ? void 0 : _feature$geometry3.type) === "MultiPolygon") && czmlTemplate !== null && czmlTemplate !== void 0 && czmlTemplate.polygon) {
          var _feature$geometry4;
          const czml = clone(czmlTemplate !== null && czmlTemplate !== void 0 ? czmlTemplate : {}, true);

          // To handle both Polygon and MultiPolygon - transform Polygon coords into MultiPolygon coords
          const multiPolygonGeom = ((_feature$geometry4 = feature.geometry) === null || _feature$geometry4 === void 0 ? void 0 : _feature$geometry4.type) === "Polygon" ? [feature.geometry.coordinates] : feature.geometry.coordinates;

          // Loop through Polygons in MultiPolygon
          for (let j = 0; j < multiPolygonGeom.length; j++) {
            var _czml$properties2, _feature$properties2;
            const geom = multiPolygonGeom[j];
            const positions = [];
            const holes = [];
            geom[0].forEach(coords => {
              var _this$czmlTemplate2;
              if (isJsonNumber((_this$czmlTemplate2 = this.czmlTemplate) === null || _this$czmlTemplate2 === void 0 ? void 0 : _this$czmlTemplate2.heightOffset)) {
                var _coords$;
                coords[2] = ((_coords$ = coords[2]) !== null && _coords$ !== void 0 ? _coords$ : 0) + this.czmlTemplate.heightOffset;
              }
              positions.push(coords[0], coords[1], coords[2]);
            });
            geom.forEach((ring, idx) => {
              if (idx === 0) return;
              holes.push(ring.reduce((acc, current) => {
                var _this$czmlTemplate3;
                if (isJsonNumber((_this$czmlTemplate3 = this.czmlTemplate) === null || _this$czmlTemplate3 === void 0 ? void 0 : _this$czmlTemplate3.heightOffset)) {
                  var _current$;
                  current[2] = ((_current$ = current[2]) !== null && _current$ !== void 0 ? _current$ : 0) + this.czmlTemplate.heightOffset;
                }
                acc.push(current[0], current[1], current[2]);
                return acc;
              }, []));
            });
            czml.polygon.positions = {
              cartographicDegrees: positions
            };
            czml.polygon.holes = {
              cartographicDegrees: holes
            };
            czml.properties = Object.assign((_czml$properties2 = czml.properties) !== null && _czml$properties2 !== void 0 ? _czml$properties2 : {}, stringifyFeatureProperties((_feature$properties2 = feature.properties) !== null && _feature$properties2 !== void 0 ? _feature$properties2 : {}));
            rootCzml.push(czml);
          }
        } else if (((feature === null || feature === void 0 || (_feature$geometry5 = feature.geometry) === null || _feature$geometry5 === void 0 ? void 0 : _feature$geometry5.type) === "LineString" || ((_feature$geometry6 = feature.geometry) === null || _feature$geometry6 === void 0 ? void 0 : _feature$geometry6.type) === "MultiLineString") && (czmlTemplate !== null && czmlTemplate !== void 0 && czmlTemplate.polyline || czmlTemplate !== null && czmlTemplate !== void 0 && czmlTemplate.polylineVolume || czmlTemplate !== null && czmlTemplate !== void 0 && czmlTemplate.wall || czmlTemplate !== null && czmlTemplate !== void 0 && czmlTemplate.corridor)) {
          var _feature$geometry7;
          const czml = clone(czmlTemplate !== null && czmlTemplate !== void 0 ? czmlTemplate : {}, true);

          // To handle both Polygon and MultiPolygon - transform Polygon coords into MultiPolygon coords
          const multiLineString = ((_feature$geometry7 = feature.geometry) === null || _feature$geometry7 === void 0 ? void 0 : _feature$geometry7.type) === "LineString" ? [feature.geometry.coordinates] : feature.geometry.coordinates;

          // Loop through Polygons in MultiPolygon
          for (let j = 0; j < multiLineString.length; j++) {
            var _czml$properties3, _feature$properties3;
            const geom = multiLineString[j];
            const positions = [];
            geom.forEach(coords => {
              var _this$czmlTemplate4;
              if (isJsonNumber((_this$czmlTemplate4 = this.czmlTemplate) === null || _this$czmlTemplate4 === void 0 ? void 0 : _this$czmlTemplate4.heightOffset)) {
                var _coords$2;
                coords[2] = ((_coords$2 = coords[2]) !== null && _coords$2 !== void 0 ? _coords$2 : 0) + this.czmlTemplate.heightOffset;
              }
              positions.push(coords[0], coords[1], coords[2]);
            });

            // Add positions to all CZML line like features
            if (czml.polyline) {
              czml.polyline.positions = {
                cartographicDegrees: positions
              };
            }
            if (czml.polylineVolume) {
              czml.polylineVolume.positions = {
                cartographicDegrees: positions
              };
            }
            if (czml.wall) {
              czml.wall.positions = {
                cartographicDegrees: positions
              };
            }
            if (czml.corridor) {
              czml.corridor.positions = {
                cartographicDegrees: positions
              };
            }
            czml.properties = Object.assign((_czml$properties3 = czml.properties) !== null && _czml$properties3 !== void 0 ? _czml$properties3 : {}, stringifyFeatureProperties((_feature$properties3 = feature.properties) !== null && _feature$properties3 !== void 0 ? _feature$properties3 : {}));
            rootCzml.push(czml);
          }
        }
      }
      return CzmlDataSource.load(rootCzml);
    }
    get defaultStyles() {
      var _this$name, _this$name2, _this$name3;
      return {
        markerSize: 24,
        markerColor: getRandomCssColor((_this$name = this.name) !== null && _this$name !== void 0 ? _this$name : ""),
        stroke: getColor(this.terria.baseMapContrastColor),
        markerStroke: getColor(this.terria.baseMapContrastColor),
        polygonStroke: getColor(this.terria.baseMapContrastColor),
        polylineStroke: getRandomCssColor((_this$name2 = this.name) !== null && _this$name2 !== void 0 ? _this$name2 : ""),
        markerStrokeWidth: 1,
        polylineStrokeWidth: 2,
        polygonStrokeWidth: 1,
        fill: getRandomCssColor(((_this$name3 = this.name) !== null && _this$name3 !== void 0 ? _this$name3 : "") + " fill"),
        fillAlpha: 0.75
      };
    }

    /** Applies default values on top of GeoJson StyleTraits. This is only used for Cesium Primitives.*/
    get stylesWithDefaults() {
      var _parseMarkerSize, _this$style$polygonS, _this$style$polyline, _this$style$markerSt, _ref4, _this$style$markerSt2, _ref5, _this$style$polyline2, _ref6, _this$style$polygonS2;
      const defaultColor = (colString, defaultColor) => colString ? getColor(colString) : defaultColor;
      const options = {
        describe: describeWithoutUnderscores,
        markerSize: (_parseMarkerSize = parseMarkerSize(this.style["marker-size"])) !== null && _parseMarkerSize !== void 0 ? _parseMarkerSize : this.defaultStyles.markerSize,
        markerSymbol: this.style["marker-symbol"],
        // and undefined if none
        markerColor: defaultColor(this.style["marker-color"], this.defaultStyles.markerColor),
        stroke: defaultColor(this.style.stroke, this.defaultStyles.stroke),
        polygonStroke: defaultColor((_this$style$polygonS = this.style["polygon-stroke"]) !== null && _this$style$polygonS !== void 0 ? _this$style$polygonS : this.style.stroke, this.defaultStyles.polygonStroke),
        // Note these specific stroke widths are only used for geojson-vt

        polylineStroke: defaultColor((_this$style$polyline = this.style["polyline-stroke"]) !== null && _this$style$polyline !== void 0 ? _this$style$polyline : this.style.stroke, this.defaultStyles.polylineStroke),
        markerStroke: defaultColor((_this$style$markerSt = this.style["marker-stroke"]) !== null && _this$style$markerSt !== void 0 ? _this$style$markerSt : this.style.stroke, this.defaultStyles.markerStroke),
        markerStrokeWidth: (_ref4 = (_this$style$markerSt2 = this.style["marker-stroke-width"]) !== null && _this$style$markerSt2 !== void 0 ? _this$style$markerSt2 : this.style["stroke-width"]) !== null && _ref4 !== void 0 ? _ref4 : this.defaultStyles.markerStrokeWidth,
        polylineStrokeWidth: (_ref5 = (_this$style$polyline2 = this.style["polyline-stroke-width"]) !== null && _this$style$polyline2 !== void 0 ? _this$style$polyline2 : this.style["stroke-width"]) !== null && _ref5 !== void 0 ? _ref5 : this.defaultStyles.polylineStrokeWidth,
        polygonStrokeWidth: (_ref6 = (_this$style$polygonS2 = this.style["polygon-stroke-width"]) !== null && _this$style$polygonS2 !== void 0 ? _this$style$polygonS2 : this.style["stroke-width"]) !== null && _ref6 !== void 0 ? _ref6 : this.defaultStyles.polygonStrokeWidth,
        markerOpacity: this.style["marker-opacity"],
        // not in SimpleStyle spec or supported by Cesium but see below
        fill: defaultColor(this.style.fill, this.defaultStyles.fill),
        clampToGround: this.clampToGround,
        markerUrl: this.style["marker-url"] // not in SimpleStyle spec but gives an alternate to maki marker symbols
        ? proxyCatalogItemUrl(this, this.style["marker-url"]) : undefined,
        credit: this.attribution
      };
      if (isDefined(this.style["stroke-opacity"])) {
        options.stroke.alpha = this.style["stroke-opacity"];
        options.polygonStroke.alpha = this.style["stroke-opacity"];
        options.polylineStroke.alpha = this.style["stroke-opacity"];
        options.markerStroke.alpha = this.style["stroke-opacity"];
      }
      if (isDefined(this.style["fill-opacity"])) {
        options.fill.alpha = this.style["fill-opacity"];
      } else {
        options.fill.alpha = this.defaultStyles.fillAlpha;
      }
      return toJS(options);
    }
    async loadGeoJsonDataSource(geoJson) {
      /* Style information is applied as follows, in decreasing priority:
            - simple-style properties set directly on individual features in the GeoJSON file
            - simple-style properties set as the 'Style' property on the catalog item
            - our 'this.styles' set below (and point styling applied after Cesium loads the GeoJSON)
            - if anything is underspecified there, then Cesium's defaults come in.
            See https://github.com/mapbox/simplestyle-spec/tree/master/1.1.0
      */

      this.addPerPropertyStyleToGeoJson(geoJson);
      const now = JulianDate.now();
      const styles = runInAction(() => this.stylesWithDefaults);
      const dataSource = await GeoJsonDataSource.load(geoJson, styles);
      const entities = dataSource.entities;
      for (let i = 0; i < entities.values.length; ++i) {
        var _properties$markerOp2;
        const entity = entities.values[i];
        const properties = entity.properties;

        // Time
        if (isDefined(properties) && isDefined(this.timeProperty) && isDefined(this.discreteTimesAsSortedJulianDates)) {
          var _this$discreteTimesAs;
          const startTimeDiscreteTime = properties[this.timeProperty];
          const startTimeIdx = (_this$discreteTimesAs = this.discreteTimesAsSortedJulianDates) === null || _this$discreteTimesAs === void 0 ? void 0 : _this$discreteTimesAs.findIndex(t => t.tag === startTimeDiscreteTime.getValue());
          const startTime = this.discreteTimesAsSortedJulianDates[startTimeIdx];
          if (isDefined(startTime)) {
            var _endTime$time;
            const endTimeIdx = startTimeIdx + 1;
            const endTime = this.discreteTimesAsSortedJulianDates[endTimeIdx];
            entity.availability = new TimeIntervalCollection([new TimeInterval({
              start: startTime.time,
              stop: (_endTime$time = endTime === null || endTime === void 0 ? void 0 : endTime.time) !== null && _endTime$time !== void 0 ? _endTime$time : Iso8601.MAXIMUM_VALUE,
              isStopIncluded: false
            })]);
          }
        }

        // Billboard
        if (isDefined(entity.billboard) && isDefined(styles.markerUrl)) {
          entity.billboard = new BillboardGraphics({
            image: new ConstantProperty(styles.markerUrl),
            width: properties && properties["marker-width"] ? new ConstantProperty(properties["marker-width"]) : undefined,
            height: properties && properties["marker-height"] ? new ConstantProperty(properties["marker-height"]) : undefined,
            rotation: properties && properties["marker-angle"] ? new ConstantProperty(properties["marker-angle"]) : undefined,
            heightReference: styles.clampToGround ? new ConstantProperty(HeightReference.RELATIVE_TO_GROUND) : undefined
          });

          /* If no marker symbol was provided but Cesium has generated one for a point, then turn it into
               a filled circle instead of the default marker. */
        } else if (isDefined(entity.billboard) && (!properties || !isDefined(properties["marker-symbol"])) && !isDefined(styles.markerSymbol)) {
          var _properties$markerCo, _properties$markerCo2, _parseMarkerSize2, _properties$markerSi, _properties$strokeWi, _properties$strokeWi2, _properties$stroke$ge, _properties$stroke;
          entity.point = new PointGraphics({
            color: new ConstantProperty(getColor((_properties$markerCo = properties === null || properties === void 0 || (_properties$markerCo2 = properties["marker-color"]) === null || _properties$markerCo2 === void 0 ? void 0 : _properties$markerCo2.getValue()) !== null && _properties$markerCo !== void 0 ? _properties$markerCo : styles.markerColor)),
            pixelSize: new ConstantProperty((_parseMarkerSize2 = parseMarkerSize(properties && ((_properties$markerSi = properties["marker-size"]) === null || _properties$markerSi === void 0 ? void 0 : _properties$markerSi.getValue()))) !== null && _parseMarkerSize2 !== void 0 ? _parseMarkerSize2 : styles.markerSize / 2),
            outlineWidth: new ConstantProperty((_properties$strokeWi = properties === null || properties === void 0 || (_properties$strokeWi2 = properties["stroke-width"]) === null || _properties$strokeWi2 === void 0 ? void 0 : _properties$strokeWi2.getValue()) !== null && _properties$strokeWi !== void 0 ? _properties$strokeWi : styles.markerStrokeWidth),
            outlineColor: new ConstantProperty(getColor((_properties$stroke$ge = properties === null || properties === void 0 || (_properties$stroke = properties.stroke) === null || _properties$stroke === void 0 ? void 0 : _properties$stroke.getValue()) !== null && _properties$stroke$ge !== void 0 ? _properties$stroke$ge : styles.polygonStroke)),
            heightReference: new ConstantProperty(styles.clampToGround ? HeightReference.RELATIVE_TO_GROUND : undefined),
            disableDepthTestDistance: this.disableDepthTest ? new ConstantProperty(Number.POSITIVE_INFINITY) : undefined
          });
          if (properties && isDefined(properties["marker-opacity"]) && entity.point.color) {
            var _properties$markerOp;
            // not part of SimpleStyle spec, but why not?
            const color = entity.point.color.getValue(now);
            color.alpha = parseFloat((_properties$markerOp = properties["marker-opacity"]) === null || _properties$markerOp === void 0 ? void 0 : _properties$markerOp.getValue());
          }
          entity.billboard = undefined;
        }
        if (isDefined(entity.billboard) && properties && isDefined((_properties$markerOp2 = properties["marker-opacity"]) === null || _properties$markerOp2 === void 0 ? void 0 : _properties$markerOp2.getValue())) {
          var _properties$markerOp3;
          entity.billboard.color = new ConstantProperty(new Color(1, 1, 1, parseFloat((_properties$markerOp3 = properties["marker-opacity"]) === null || _properties$markerOp3 === void 0 ? void 0 : _properties$markerOp3.getValue())));
        }
        if (isDefined(entity.polygon)) {
          // Extrude polygons if heightProperty is set
          if (this.heightProperty && properties && isDefined(properties[this.heightProperty])) {
            entity.polygon.closeTop = new ConstantProperty(true);
            entity.polygon.extrudedHeight = properties[this.heightProperty];
            entity.polygon.heightReference = new ConstantProperty(HeightReference.CLAMP_TO_GROUND);
            entity.polygon.extrudedHeightReference = new ConstantProperty(HeightReference.RELATIVE_TO_GROUND);
          }
          // Cesium on Windows can't render polygons with a stroke-width > 1.0.  And even on other platforms it
          // looks bad because WebGL doesn't mitre the lines together nicely.
          // As a workaround for the special case where the polygon is unfilled anyway, change it to a polyline.
          else if (polygonHasWideOutline(entity.polygon, now) && !polygonIsFilled(entity.polygon)) {
            createPolylineFromPolygon(entities, entity, now);
            entity.polygon = undefined;
          } else if (polygonHasOutline(entity.polygon, now) && isPolygonOnTerrain(entity.polygon, now)) {
            // Polygons don't directly support outlines when they're on terrain.
            // So create a manual outline.
            createPolylineFromPolygon(entities, entity, now);
          }
        }
      }
      return dataSource;
    }
    get discreteTimes() {
      if (this.readyData === undefined) {
        return undefined;
      }

      // If we are using mvt (mapbox vector tiles / protomaps imagery provider) return TableMixin.discreteTimes
      if (this.useTableStylingAndProtomaps) return super.discreteTimes;

      // If using timeProperty - get discrete times from that
      if (this.timeProperty) {
        const discreteTimesMap = new Map();
        for (let i = 0; i < this.readyData.features.length; i++) {
          const feature = this.readyData.features[i];
          if (feature.properties !== null && feature.properties !== undefined && feature.properties[this.timeProperty] !== undefined) {
            const dt = {
              time: new Date("".concat(feature.properties[this.timeProperty])).toISOString(),
              tag: feature.properties[this.timeProperty]
            };
            discreteTimesMap.set(dt.tag, dt);
          }
        }
        return Array.from(discreteTimesMap.values());
      }
    }

    /**
     * Transform feature properties into column-major format.
     * This enables all TableMixin functionality - which is used for styling vector tiles.
     * If this returns an empty array, TableMixin will effectively be disabled
     */
    get dataColumnMajor() {
      if (!this.readyData || !this.useTableStylingAndProtomaps) return [];

      // Map from property name (column name) to column index
      const colMap = new Map();
      const dataColumnMajor = [];
      dataColumnMajor[0] = new Array(this.readyData.features.length + 1).fill("");
      for (let i = 0; i < this.readyData.features.length; i++) {
        const feature = this.readyData.features[i];

        // Loop through feature properties
        if (feature.properties) {
          for (let j = 0; j < Object.keys(feature.properties).length; j++) {
            const prop = Object.keys(feature.properties)[j];
            const value = feature.properties[prop];
            let colIndex = colMap.get(prop);

            // If column isn't in colMap - we need to create it
            if (!isDefined(colIndex)) {
              colIndex = colMap.size;
              colMap.set(prop, colIndex);
              dataColumnMajor[colIndex] = new Array(this.readyData.features.length + 1).fill("");
            }
            if (typeof value === "string") {
              dataColumnMajor[colIndex][i + 1] = value;
            } else if (typeof value === "number") {
              dataColumnMajor[colIndex][i + 1] = value.toString();
            }
          }
        }
      }

      // Set column titles
      colMap.forEach((index, prop) => {
        dataColumnMajor[index][0] = prop;
      });
      return dataColumnMajor;
    }

    /** We don't need to use TableMixin forceLoadTableData
     * We implement `get dataColumnMajor()` instead
     */
    async forceLoadTableData() {
      return undefined;
    }
    get viewingControls() {
      return !this.useTableStylingAndProtomaps ? super.viewingControls.filter(v => v.id !== TableStylingWorkflow.type) : super.viewingControls;
    }
  }, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "_dataSource", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "_imageryProvider", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "_readyData", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "featureCounts", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {
        point: 0,
        multiPoint: 0,
        line: 0,
        polygon: 0,
        simpleStyle: 0,
        total: 0
      };
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "name", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "name"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "readyData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "readyData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_canExportData", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "_canExportData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "useTableStylingAndProtomaps", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "useTableStylingAndProtomaps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "chartItems", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "chartItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addPerPropertyStyleToGeoJson", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addPerPropertyStyleToGeoJson"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createProtomapsImageryProvider", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "createProtomapsImageryProvider"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultStyles", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultStyles"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stylesWithDefaults", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "stylesWithDefaults"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "discreteTimes", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "discreteTimes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dataColumnMajor", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "dataColumnMajor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewingControls", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "viewingControls"), _class2.prototype), _class2);
  return GeoJsonMixin;
}
(function (_GeoJsonMixin2) {
  function isMixedInto(model) {
    return model && model.isGeoJson;
  }
  _GeoJsonMixin2.isMixedInto = isMixedInto;
})(GeoJsonMixin || (GeoJsonMixin = {}));
export default GeoJsonMixin;
function createPolylineFromPolygon(entities, entity, now) {
  const polygon = entity.polygon;
  entity.polyline = new PolylineGraphics();
  entity.polyline.show = polygon.show;
  if (isPolygonOnTerrain(polygon, now)) {
    entity.polyline.clampToGround = new ConstantProperty(true);
  }
  if (isDefined(polygon.outlineColor)) {
    entity.polyline.material = new ColorMaterialProperty(polygon.outlineColor);
  }
  const hierarchy = getPropertyValue(polygon.hierarchy);
  if (!hierarchy) {
    return;
  }
  const positions = closePolyline(hierarchy.positions);
  entity.polyline.positions = new ConstantProperty(positions);
  entity.polyline.width = polygon.outlineWidth && polygon.outlineWidth.getValue(now);
  createEntitiesFromHoles(entities, hierarchy.holes, entity);
}
export async function reprojectToGeographic(geoJson, proj4ServiceBaseUrl) {
  let code;
  if (!isJsonObject(geoJson.crs)) {
    code = undefined;
  } else if (geoJson.crs.type === "EPSG" && isJsonObject(geoJson.crs.properties) && typeof geoJson.crs.properties.code === "string") {
    code = "EPSG:" + geoJson.crs.properties.code;
  } else if (isJsonObject(geoJson.crs.properties) && geoJson.crs.type === "name" && typeof geoJson.crs.properties.name === "string") {
    code = Reproject.crsStringToCode(geoJson.crs.properties.name);
  }
  geoJson.crs = {
    type: "EPSG",
    properties: {
      code: "4326"
    }
  };
  if (!code || !Reproject.willNeedReprojecting(code)) {
    return Promise.resolve(geoJson);
  }
  const needsReprojection = proj4ServiceBaseUrl ? await Reproject.checkProjection(proj4ServiceBaseUrl, code) : false;
  if (needsReprojection) {
    try {
      filterValue(geoJson, "coordinates", function (obj, prop) {
        obj[prop] = filterArray(obj[prop], function (pts) {
          if (pts.length === 0) return [];
          return reprojectPointList(pts, code);
        });
      });
      return geoJson;
    } catch (e) {
      throw TerriaError.from(e, "Failed to reproject geoJSON");
    }
  } else {
    throw new DeveloperError("The crs code for this datasource is unsupported.");
  }
}
// Reproject a point list based on the supplied crs code.
function reprojectPointList(pts, code) {
  if (!code) return [];
  if (!Array.isArray(pts[0])) {
    var _Reproject$reprojectP;
    return (_Reproject$reprojectP = Reproject.reprojectPoint(pts, code, "EPSG:4326")) !== null && _Reproject$reprojectP !== void 0 ? _Reproject$reprojectP : [];
  }
  const pts_out = [];
  for (let i = 0; i < pts.length; i++) {
    var _Reproject$reprojectP2;
    const pt = pts[i];
    if (Array.isArray(pt)) pts_out.push((_Reproject$reprojectP2 = Reproject.reprojectPoint(pt, code, "EPSG:4326")) !== null && _Reproject$reprojectP2 !== void 0 ? _Reproject$reprojectP2 : []);
  }
  return pts_out;
}

// Find a member by name in the gml.
function filterValue(obj, prop, func) {
  for (const p in obj) {
    if (Object.hasOwnProperty.call(obj, p) === false) {
      continue;
    } else if (p === prop) {
      if (func && typeof func === "function") {
        func(obj, prop);
      }
    } else if (typeof obj[p] === "object") {
      filterValue(obj[p], prop, func);
    }
  }
}

// Filter a geojson coordinates array structure.
function filterArray(pts, func) {
  if (!(pts[0] instanceof Array) || !(pts[0][0] instanceof Array)) {
    pts = func(pts);
    return pts;
  }
  const result = new Array(pts.length);
  for (let i = 0; i < pts.length; i++) {
    result[i] = filterArray(pts[i], func); // at array of arrays of points
  }
  return result;
}

/**
 * Get a random color for the data based on the passed string (usually dataset name).
 */
function getRandomCssColor(name) {
  let cssColors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : StandardCssColors.highContrast;
  const index = hashFromString(name) % cssColors.length;
  const color = Color.fromCssColorString(cssColors[index]);
  color.alpha = 1;
  return color;
}
const simpleStyleIdentifiers = ["title", "description", "marker-size", "marker-symbol", "marker-color", "stroke", "stroke-opacity", "stroke-width", "fill", "fill-opacity"];

// This next function modelled on Cesium.geoJsonDataSource's defaultDescribe.
function describeWithoutUnderscores(properties, nameProperty) {
  let html = "";
  for (let key in properties) {
    if (Object.hasOwnProperty.call(properties, key)) {
      if (key === nameProperty || simpleStyleIdentifiers.indexOf(key) !== -1) {
        continue;
      }
      let value = properties[key];
      if (typeof value === "object") {
        value = describeWithoutUnderscores(value);
      } else {
        value = formatPropertyValue(value);
      }
      key = key.replace(/_/g, " ");
      if (isDefined(value)) {
        html += "<tr><th>" + key + "</th><td>" + value + "</td></tr>";
      }
    }
  }
  if (html.length > 0) {
    html = '<table class="cesium-infoBox-defaultTable"><tbody>' + html + "</tbody></table>";
  }
  return html;
}
function polygonHasOutline(polygon, now) {
  return isDefined(polygon.outlineWidth) && polygon.outlineWidth.getValue(now) > 0;
}
function polygonHasWideOutline(polygon, now) {
  return isDefined(polygon.outlineWidth) && polygon.outlineWidth.getValue(now) > 1;
}
function polygonIsFilled(polygon) {
  let fill = true;
  if (isDefined(polygon.fill)) {
    fill = polygon.fill.getValue(new JulianDate());
  }
  if (!fill) {
    return false;
  }
  if (!isDefined(polygon.material)) {
    // The default is solid white.
    return true;
  }
  let color;
  if (polygon.material instanceof Color) {
    color = polygon.material.getValue(new JulianDate());
  } else {
    var _color;
    color = (_color = polygon.material.color) === null || _color === void 0 ? void 0 : _color.getValue(new JulianDate());
  }
  if (color && color.alpha === 0.0) {
    return false;
  }
  return true;
}
function closePolyline(positions) {
  // If the first and last positions are more than a meter apart, duplicate the first position so the polyline is closed.
  if (positions.length >= 2 && !Cartesian3.equalsEpsilon(positions[0], positions[positions.length - 1], 0.0, 1.0)) {
    const copy = positions.slice();
    copy.push(positions[0]);
    return copy;
  }
  return positions;
}
function createEntitiesFromHoles(entityCollection, holes, mainEntity) {
  if (!isDefined(holes)) {
    return;
  }
  for (let i = 0; i < holes.length; ++i) {
    createEntityFromHole(entityCollection, holes[i], mainEntity);
  }
}
function createEntityFromHole(entityCollection, hole, mainEntity) {
  if (!isDefined(hole) || !isDefined(hole.positions) || hole.positions.length === 0) {
    return;
  }
  const entity = new Entity();
  entity.name = mainEntity.name;
  entity.availability = mainEntity.availability;
  entity.description = mainEntity.description;
  entity.properties = mainEntity.properties;
  entity.polyline = new PolylineGraphics();
  entity.polyline.show = mainEntity.polyline.show;
  entity.polyline.material = mainEntity.polyline.material;
  entity.polyline.width = mainEntity.polyline.width;
  entity.polyline.clampToGround = mainEntity.polyline.clampToGround;
  closePolyline(hole.positions);
  entity.polyline.positions = new ConstantProperty(hole.positions);
  entityCollection.add(entity);
  createEntitiesFromHoles(entityCollection, hole.holes, mainEntity);
}
function getPropertyValue(property) {
  if (property === undefined) {
    return undefined;
  }
  return property.getValue(JulianDate.now());
}
function isPolygonOnTerrain(polygon, now) {
  const polygonAny = polygon;
  const isClamped = polygonAny.heightReference && polygonAny.heightReference.getValue(now) === HeightReference.CLAMP_TO_GROUND;
  const hasPerPositionHeight = polygon.perPositionHeight && polygon.perPositionHeight.getValue(now);
  const hasPolygonHeight = polygon.height && polygon.height.getValue(now) !== undefined;
  return isClamped || !hasPerPositionHeight && !hasPolygonHeight;
}
export function getColor(color) {
  if (typeof color === "string" || color instanceof String) {
    var _Color$fromCssColorSt;
    return (_Color$fromCssColorSt = Color.fromCssColorString(color.toString())) !== null && _Color$fromCssColorSt !== void 0 ? _Color$fromCssColorSt : Color.GRAY;
  } else {
    return color;
  }
}
export function parseMarkerSize(sizeString) {
  const sizes = {
    small: 24,
    medium: 48,
    large: 64
  };
  if (sizeString === undefined) {
    return undefined;
  }
  if (sizes[sizeString] !== undefined) {
    return sizes[sizeString];
  }
  return parseInt(sizeString, 10); // SimpleStyle doesn't allow 'marker-size: 20', but people will do it.
}
function stringifyFeatureProperties(featureProps) {
  return Object.keys(featureProps !== null && featureProps !== void 0 ? featureProps : {}).reduce((properties, key) => {
    const featureProp = featureProps[key];
    if (typeof featureProp === "string") {
      properties[key] = featureProp;
    } else if (isDefined(featureProp) && featureProp !== null && typeof featureProp.toString === "function") properties[key] = featureProp.toString();
    return properties;
  }, {});
}
export function getStyleReactiveDependencies(item) {
  return [item.useTableStylingAndProtomaps, item.readyData, item.currentDiscreteJulianDate, item.activeTableStyle.timeIntervals, item.activeTableStyle.colorMap, item.activeTableStyle.pointSizeMap, item.activeTableStyle.pointStyleMap.traitValues, item.activeTableStyle.outlineStyleMap.traitValues, item.terria.baseMapContrastColor // This needs to be here as `baseMapContrastColor` is used as the default outline color in `getFeatureStyle`
  ];
}